export function isEffectivelyZero(value: string | number): boolean {
  if (typeof value === 'number') return value === 0;
  const num = parseFloat(String(value).replace(/[^0-9.-]/g, ''));
  return !Number.isNaN(num) && num === 0;
}
